'use strict';

export default angular
  .module('maestro.filters.htmlSafe', [])

  .filter('htmlSafe', function($sce) {
    return function(htmlCode) {
      return $sce.trustAsHtml(htmlCode);
    };
  })

  .name;
